import React from "react";
import { Link } from "react-router-dom";

const Logo = ({ light = false }) => {
  const color = light ? "#ffffff" : "#2b2b2b";
  return (
    <Link to="/" className="flex items-center gap-2 group">
      <svg width="30" height="22" viewBox="0 0 30 22" fill="none" className="transition-transform duration-300 group-hover:scale-105">
        <path d="M2 20 C2 9 8 3 15 3 C22 3 28 9 28 20" stroke="#b8935f" strokeWidth="1.6" fill="none" strokeLinecap="round" />
        <path d="M7 20 C7 12 10 8 15 8 C20 8 23 12 23 20" stroke="#b8935f" strokeWidth="1.2" fill="none" strokeLinecap="round" opacity="0.7" />
        <line x1="15" y1="1" x2="15" y2="6" stroke="#b8935f" strokeWidth="1.4" strokeLinecap="round" />
      </svg>
      <div className="flex flex-col leading-none">
        <span className="font-display text-[15px] font-500 tracking-[0.28em]" style={{ color }}>
          ANADEAR
        </span>
        <span className="font-display text-[9px] tracking-[0.42em] mt-[3px]" style={{ color: "#b8935f" }}>
          ESTATES
        </span>
      </div>
    </Link>
  );
};

export default Logo;
